export default __webpack_public_path__ + "static/media/webshelves.c79680e2.png";